import { render, staticRenderFns } from "./MainFrame.vue?vue&type=template&id=52a687f5"
import script from "./MainFrame.vue?vue&type=script&lang=js"
export * from "./MainFrame.vue?vue&type=script&lang=js"
import style0 from "./MainFrame.vue?vue&type=style&index=0&id=52a687f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports